import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/client';
import './Cadastro.css';

/**
 * Página de Auto-Cadastro (pública)
 * Permite que jogadores se cadastrem, mas ficam inativos até aprovação do admin
 */

const Cadastro = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validações
    if (!formData.nome || !formData.email || !formData.senha) {
      setError('Todos os campos são obrigatórios');
      setLoading(false);
      return;
    }

    if (formData.senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      setLoading(false);
      return;
    }

    if (formData.senha !== formData.confirmarSenha) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    try {
      // Auto-cadastro público (rota sem autenticação)
      const response = await apiClient.post('/jogadores/cadastro', {
        nome: formData.nome,
        email: formData.email,
        senha: formData.senha,
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      console.error('Erro no cadastro:', err);
      setError(err.response?.data?.error || 'Erro ao realizar cadastro. Email já cadastrado?');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="cadastro-container">
        <div className="cadastro-box">
          <h1>✅ Cadastro Realizado!</h1>
          <p>Seu cadastro foi enviado com sucesso!</p>
          <p>
            <strong>Você está pendente de aprovação do administrador.</strong>
          </p>
          <p>Assim que um administrador aprovar seu cadastro, você poderá fazer login.</p>
          <p>Redirecionando para login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cadastro-container">
      <div className="cadastro-box">
        <h1>🃏 NerdzPoker</h1>
        <h2>Novo Cadastro</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome Completo</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Digite seu nome"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="seu@email.com"
            />
          </div>

          <div className="form-group">
            <label>Senha</label>
            <input
              type="password"
              name="senha"
              value={formData.senha}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Mínimo 6 caracteres"
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label>Confirmar Senha</label>
            <input
              type="password"
              name="confirmarSenha"
              value={formData.confirmarSenha}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Digite a senha novamente"
            />
          </div>

          {error && <div className="error">{error}</div>}

          <div className="info-box">
            <strong>⚠️ Importante:</strong>
            <p>Seu cadastro ficará pendente de aprovação do administrador. Você receberá acesso ao sistema assim que for aprovado.</p>
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Cadastrando...' : 'Cadastrar'}
          </button>

          <div className="cadastro-footer">
            <p>Já tem uma conta? <Link to="/login">Faça login aqui</Link></p>
            <div className="cadastro-footer-links">
              <Link to="/privacidade">Política de Privacidade</Link>
              <span> | </span>
              <Link to="/termos">Termos de Serviço</Link>
            </div>
            <p className="footer-signature">Produzido by <strong>Chicão</strong></p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Cadastro;
